import { format, parse } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { CuraLabel } from '@rededor/cura-react'
import * as S from './styles'

interface Props {
  date: string
}

export const IconDate = ({ date }: Props) => {
  const parsedDate = parse(date, 'yyyy-MM-dd', new Date())

  const textDay = format(parsedDate, 'dd')
  const textMonth = format(parsedDate, 'MMM', { locale: ptBR }).toUpperCase()

  return (
    <S.Container>
      <CuraLabel size="large" color="primary" weight="regular">
        {textDay}
      </CuraLabel>
      <CuraLabel size="xsmall" color="primary" weight="regular">
        {textMonth}
      </CuraLabel>
    </S.Container>
  )
}
